import { parseISO, format, formatISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const CONFLICT_SCHEDULED_BANNERS_ERROR_TYPE =
	"Schedule Conflicting Error. The new schedule conflicts with existing banner's schedule";
export const CONFLICT_ACTIVE_BANNER_ERROR_TYPE =
	'Schedule Conflicting Error. Existing Banner currently active';

// Helper that takes date and time picker inputs and outputs a formatted date string that BE can accept, or null
export const getScheduledDateStringFromPickerValues = ({
	datePickerStr,
	timePickerStr,
}: {
	datePickerStr?: string;
	timePickerStr?: string;
}) => {
	if (!datePickerStr) {
		return null;
	}
	const formattedDateStr = format(parseISO(datePickerStr), 'MM/dd/yyyy');
	const formattedTimeStr = `${timePickerStr || '00:00'}:00`;
	return `${formattedDateStr} ${formattedTimeStr}`;
};

// Helper that takes a Date object and outputs a formatted date string that BE can accept
export const getScheduledDateStringFromDate = (date: Date) => format(date, 'MM/dd/yyyy HH:mm:ss');

// Helper that takes a Date object and outputs a formatted date string relative to the UTC timezone that BE can accept
export const getScheduledUTCDateStringFromDate = (date: Date) =>
	formatInTimeZone(date, 'UTC', 'MM/dd/yyyy HH:mm:ss');

// Helper that takes a BE date string and transforms it into a formatted date string that BE can accept
export const transformScheduledDateString = (scheduledDateStr: string, timezone: string = 'UTC') =>
	formatInTimeZone(parseISO(scheduledDateStr), timezone, 'MM/dd/yyyy HH:mm:ss');

// Helper that takes a BE date string and formats it as a date picker value
export const getDateFromScheduledDateString = (scheduledDateStr: string) =>
	formatISO(parseISO(scheduledDateStr), { representation: 'date' });

// Helper that takes a BE date string and formats it as a time picker value
export const getTimeFromScheduledDateString = (scheduledDateStr: string) =>
	format(parseISO(scheduledDateStr), 'HH:mm');

// Helper that takes a BE date string and formats it as a readable date string for conflicting schedules
export const getConflictingDateTimeFromScheduledDateString = (scheduledDateStr: string) =>
	format(parseISO(scheduledDateStr), 'MMM d, yyyy h:mmaaa');

// Helper that takes a JS date string and formats it as a readable date string for banner section message
export const getSectionMessageDateTimeFromDateString = (dateStr: string) =>
	format(new Date(dateStr), 'MMM d, yyyy h:mmaaa');
